import React, { memo } from 'react';

interface Step1Props {}

const Step1: React.FC<Step1Props> = () => {
  return (
    <div className="text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">
        Welcome! Let’s Get You Set Up in Minutes
      </h2>
      <p className="text-lg text-gray-600 mb-2 mx-20">
        This quick 2-minute video shows what to expect during setup. Watch now
        or click ‘Next’ to jump in.
      </p>

      <div
        className="w-full"
        dangerouslySetInnerHTML={{
          __html: `<div style="position: relative; box-sizing: content-box; max-height: 80vh; max-height: 80svh; width: 100%; aspect-ratio: 1.7777777777777777; padding: 40px 0 40px 0;"><iframe src="https://guides.shipaid.com/embed/cmd56c1yz021u0x0jr271ixax?embed_v=2" loading="lazy" title="New Demo" allow="clipboard-write" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`,
        }}
      />

      <p className="text-sm text-gray-500 mb-8">
        ⏱️ 2 min founder intro on what to expect during setup.
      </p>
    </div>
  );
};

export default memo(Step1);
